<template>
  <el-dialog
    :title="typeof webhook.id !== 'undefined' ? 'Edit Webhook' : 'Create Webhook'"
    visible
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="webhookForm"
      :rules="rules"
      :model="webhook"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Endpoint"
            prop="endpoint"
          >
            <el-input
              v-model="webhook.endpoint"
              placeholder="URL"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="Event"
            prop="event"
          >
            <el-select
              v-model="webhook.event"
              value-key="value"
              placeholder="Select an event"
              class="w-100"
            >
              <el-option
                v-for="event in events"
                :key="event.value"
                :label="event.name"
                :value="event.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof webhook.id !== 'undefined' ? updateWebhook() : createWebhook()"
      >
        {{ typeof webhook.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    webhook: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      rules: {
        profile: [
          { required: true, message: 'Event is required', trigger: 'change' }
        ],
        role: [
          { required: true, message: 'Endpoint is required', trigger: 'change' }
        ]
      },
      events: [
        {
          name: 'Manifested',
          value: 'tracking-manifested'
        },
        {
          name: 'Onboard for Delivery',
          value: 'tracking-onboardForDelivery'
        },
        {
          name: 'Delivered',
          value: 'tracking-delivered'
        },
        {
          name: 'Proof of Delivery',
          value: 'tracking-proofOfDelivery'
        },
        {
          name: 'Error',
          value: 'tracking-error'
        },
        {
          name: 'Potential Problem',
          value: 'tracking-potentialProblem'
        },
        {
          name: 'In Transit Possible Delay',
          value: 'tracking-inTransitPossibleDelay'
        },
        {
          name: 'In Transit',
          value: 'tracking-inTransit'
        },
        {
          name: 'Picked Up',
          value: 'tracking-pickedUp'
        }
      ]
    }
  },
  methods: {
    createWebhook () {
      this.isSaving = true
      this.$sdk.account_webhook.create(this.webhook, builder => {
        builder.context = { resource: 'account', id: this.accountId }
      })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('saved')
          this.$emit('update:isShow', false)
        })
    },
    updateWebhook () {
      this.isSaving = true
      this.webhook.update(builder => {
        builder.context = { resource: 'account', id: this.accountId }
      })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('saved')
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>

<style>

</style>
